<template>
  <div :class="classNames">
    <div class="bounce1" />
    <div class="bounce2" />
    <div class="bounce3" />
  </div>
</template>

<script>
  const sizes = ['xs', 'sm', 'md', 'lg', 'xl']

  export default {
    name: 'Spinner',
    props: {
      mono: {
        type: Boolean,
        default: false,
      },
      inverted: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        validator: val => sizes.includes(val),
        default: 'md',
      },
    },
    computed: {
      classNames () {
        const classNames = ['spinner', `spinner-${this.size}`]

        if (this.mono === true) {
          classNames.push('mono')

          if (this.inverted === true) {
            classNames.push('inverted')
          }
        }

        return classNames
      },
    },
  }
</script>

<style lang="scss">
  @import "~assets/scss/frontend/colours";
  @import "~foundation-sites/scss/global";
  @import "~foundation-sites/scss/util/flex";
  @import "~foundation-sites/scss/util/unit";

  $spinner-element-width: 1rem;
  $spinner-width: ($spinner-element-width * 3) + rem-calc(5);

  $sizes: (
    xs: (side: .4rem, padding-x: rem-calc(1)),
    sm: (side: .65rem, padding-x: rem-calc(3)),
    md: (side: .9rem, padding-x: rem-calc(5)),
    lg: (side: 1.4rem, padding-x: rem-calc(8)),
    xl: (side: 2rem, padding-x: rem-calc(12)),
  );

  .spinner {
    @include flex();
    @include flex-align(justify, middle);
    margin: 0 auto;
    text-align: center;

    /**
     * Container size management.
     */
    @each $size, $vars in $sizes {
      &-#{$size} {
        // The height should be exactly the height of a single "bounce" element.
        height: map-get($vars, side);
        width: map-get($vars, side) * 3 + (map-get($vars, padding-x) / 2);

        .bounce1,
        .bounce2,
        .bounce3 {
          width: map-get($vars, side);
          height: map-get($vars, side);
        }
      }
    }

    & > div {
      @include flex();
      border-radius: 100%;
      animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    }

    .bounce1 {
      animation-delay: -0.32s;
      background-color: $colour-green;
    }

    .bounce2 {
      animation-delay: -0.16s;
      background-color: $colour-orange;
    }

    .bounce3 {
      background-color: $colour-purple;
    }

    /** Colours management */
    &.mono {
      .bounce1,
      .bounce2,
      .bounce3 {
        background-color: $colour-white;
      }
    }
    &.mono.inverted {
      .bounce1,
      .bounce2,
      .bounce3 {
        background-color: $colour-grey-200;
      }
    }
  }

  @-webkit-keyframes sk-bouncedelay {
    0%, 80%, 100% { -webkit-transform: scale(0) }
    40% { -webkit-transform: scale(1.0) }
  }

  @keyframes sk-bouncedelay {
    0%, 80%, 100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    } 40% {
        -webkit-transform: scale(1.0);
        transform: scale(1.0);
      }
  }
</style>
